/**
 * @description Sleep score configuration.
 * @exports
 */
export const SLEEP_SCORE_CONFIG = {
  /**
   * Number of hours to subtract from current time when fetching sleep data.
   * This accounts for sleep that may have started the previous day.
   */
  HOURS_OFFSET_FOR_SLEEP_START: 6
} as const;
